import React from "react";
import { useLocation } from "react-router-dom";
import { MdAccessTime, MdOutlineMail } from "react-icons/md";
import { GrFacebookOption } from "react-icons/gr";
import { FaInstagram, FaLinkedinIn } from "react-icons/fa";
import '../../src/assets/css/style.css';

const HeaderSection = ({ onAppointmentClick, openModal }) => {
    const location = useLocation();  

    const isHomePage = location.pathname === "/";

    return (
        <header className="custom-padding xl-screen-padding bg-[#1e2a38] text-white flex justify-between items-center hidden md:flex sm:flex">
            <div className="flex flex-wrap md:flex-nowrap items-center space-x-4 justify-center md:justify-start w-full md:w-auto">
                <div className="flex items-center space-x-1">
                    <span className="text-[#6DBE45]"><MdAccessTime /></span>
                    <span className="text-xs sm:text-sm font-lato">Mon-Sat: 10am to 7pm</span>
                </div>
            </div>
            <div className="flex flex-wrap md:flex-nowrap items-center justify-center md:justify-end space-x-4 w-full md:w-auto mt-2 md:mt-0">
                <div className="flex items-center space-x-1">
                    <span className="text-[#6DBE45]"><MdOutlineMail /></span>
                    <span className="text-xs sm:text-sm font-lato">info@nutrillion.one</span>
                </div>
                <div className="flex space-x-2">
                    <a href="https://www.facebook.com/people/Nutrillionofficial/61585798517692/" className="text-white text-xs" target="_blank" rel="noopener noreferrer">
                        <GrFacebookOption />
                    </a>
                    <a href="https://www.instagram.com/nutrillion.official" className="text-white text-xs" target="_blank" rel="noopener noreferrer">
                        <FaInstagram />
                    </a>
                    <a href="https://www.linkedin.com/company/nutrivison-wellness-and-genetics-private-limited/" className="text-white text-xs" target="_blank" rel="noopener noreferrer">
                        <FaLinkedinIn />
                    </a>
                </div>
                {isHomePage ? (
                    <button
                        className="bg-[#7c517e] text-white text-xs px-3 py-1 md:px-6 md:py-2 mt-2 md:mt-0 whitespace-nowrap w-full md:w-auto"
                        onClick={onAppointmentClick}  
                    >
                        BOOK APPOINTMENT
                    </button>
                ) : (
                    <button
                        className="bg-[#7c517e] text-white text-xs px-3 py-1 md:px-6 md:py-2 mt-2 md:mt-0 whitespace-nowrap w-full md:w-auto"
                        onClick={openModal}  
                    >
                        BOOK APPOINTMENT
                    </button>
                )}
            </div>
        </header>
    );
};

export default HeaderSection;
